import React, { ReactNode, CSSProperties } from "react"
import * as styles from "./Section.module.css"
import classNames from "classnames"

type SectionProps = {
  direction?: "row" | "column"
  x?: "left" | "center" | "right"
  y?: "top" | "center" | "bottom"
  fullResponsive?: boolean
  centerResponsive?:boolean
  children: ReactNode
  style?: CSSProperties
}

const Section = ({
  direction = "column",
  x = "center",
  y = "center",
  fullResponsive = false,
  centerResponsive = false,
  children,
  style = {},
}: SectionProps) => {
  //
  const containerStyle: CSSProperties = {
    position: "relative",
    display: "flex",
    flexDirection: direction,
    justifyContent: (() => {
      switch (direction) {
        case "row":
          switch (x) {
            case "left":
              return "flex-start"
            case "center":
              return "center"
            case "right":
              return "flex-end"
          }
        case "column":
          switch (y) {
            case "top":
              return "flex-start"
            case "center":
              return "center"
            case "bottom":
              return "flex-end"
            default:
              return "center"
          }
      }
    })(),
    alignItems: (() => {
      switch (direction) {
        case "row":
          switch (y) {
            case "top":
              return "flex-start"
            case "center":
              return "center"
            case "bottom":
              return "flex-end"
          }
        case "column":
          switch (x) {
            case "left":
              return "flex-start"
            case "center":
              return "center"
            case "right":
              return "flex-end"
            default:
              return "center"
          }
      }
    })(),
    ...style,
  }

  return (
    <div
      style={containerStyle}
      className={classNames(styles.container, {
        [styles.fullResponsive]: fullResponsive,
        [styles.centerResponsive]: centerResponsive,
      })}
    >
      {children}
    </div>
  )
}

export default Section
